import styled from 'styled-components';

export const FieldGroupWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 0 -5px;
`;

export const FieldWrapper = styled.div`
  padding: 0 5px;
  width: 100%;
`;
